// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
}

.login-box {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.login-header h1 {
  color: #333;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  margin-top: 0;
}

.login-header p {
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
  margin-top: 0;
}

.login-form {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
  text-align: left;
}

.form-group label {
  display: block;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  font-size: 14px;
}

.form-group input[type="password"] {
  width: 100%;
  padding: 14px 16px;
  font-size: 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
  background: #fff;
}

.form-group input[type="password"]:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group input[type="password"]:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.error-message {
  background-color: #fee;
  color: #c53030;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
  border: 1px solid #fed7d7;
}

.login-button {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.login-footer {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e1e5e9;
}

.login-footer p {
  color: #888;
  font-size: 14px;
  margin: 0;
}

@media (max-width: 480px) {
  .login-box {
    padding: 30px 20px;
    margin: 20px;
  }
  
  .login-header h1 {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,iHAAiH;AACnH;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,wDAAwD;EACxD,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n}\n\n.login-box {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n}\n\n.login-header h1 {\n  color: #333;\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  margin-top: 0;\n}\n\n.login-header p {\n  color: #666;\n  font-size: 16px;\n  margin-bottom: 30px;\n  margin-top: 0;\n}\n\n.login-form {\n  margin-bottom: 20px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.form-group input[type=\"password\"] {\n  width: 100%;\n  padding: 14px 16px;\n  font-size: 16px;\n  border: 2px solid #e1e5e9;\n  border-radius: 8px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  box-sizing: border-box;\n  background: #fff;\n}\n\n.form-group input[type=\"password\"]:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group input[type=\"password\"]:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.error-message {\n  background-color: #fee;\n  color: #c53030;\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  border: 1px solid #fed7d7;\n}\n\n.login-button {\n  width: 100%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 14px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.login-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.login-footer {\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #e1e5e9;\n}\n\n.login-footer p {\n  color: #888;\n  font-size: 14px;\n  margin: 0;\n}\n\n@media (max-width: 480px) {\n  .login-box {\n    padding: 30px 20px;\n    margin: 20px;\n  }\n  \n  .login-header h1 {\n    font-size: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
